import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Inventory_api } from "../../../Apiconfig";
import styles from './search_inventory.module.css';
import { ReactTransliterate } from "react-transliterate";

const SearchInventory = ({ onProductSelect }) => { // Receive callback as a prop



  const [search, setSearch] = useState(""); // Search input state
  const [products, setProducts] = useState([]); // Products data
  const [offset, setOffset] = useState(0); // Pagination offset
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(""); // Error message
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [language, setLanguage] = useState("en")

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setOffset(0);
    }, 1000);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (debouncedSearch.trim() !== "") {
      fetchProducts();
    } else {
      setProducts([]);
      setOffset(0);
    }
  }, [debouncedSearch, offset]);

  const limit = 50;

  const fetchProducts = async (append = false) => {
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${Inventory_api}/bill_Search_product.php`,
        { search: debouncedSearch, offset, limit },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data && response.data.status === "success") {
        setProducts((prevProducts) =>
          append ? [...prevProducts, ...response.data.products] : response.data.products
        );
      } else {
        setError("No products found.");
        setProducts([]);
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while fetching products.");
    } finally {
      setLoading(false);
    }
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProducts([]);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchNext = () => {
    setOffset((prevOffset) => prevOffset + limit); // Increase the offset
  };

  // Function to handle row click and send data to the parent
  const handleRowClick = (product) => {
    if (onProductSelect) {
      onProductSelect(product); // Call the callback function with selected product data
    }
  };

 

  return (
    <div>
      <div className={styles.inventorysearch_container}>
        <ReactTransliterate
         className={styles.searchBarStyle}
          type="text"
          placeholder="Search by product name, code, Hindi name, or local name"
          value={search}
          onChangeText={(newValue) => setSearch(newValue)}
          lang={language}

        />
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className={styles.languaeselector}
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="ta">Tamil</option>
          <option value="gu">Gujarati</option>

        </select>
        {/* <button className={styles.quickAddButton}>Quick Add++</button> */}
      </div>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}


      {products.length > 0 && (
        <div ref={dropdownRef} className={styles.searchInventoryProductListContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.searchInventoryProductList}>
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Hindi Name</th>
                  <th>Local Name</th>
                  <th>Quantity</th>
                  <th>Buy Price</th>
                  <th>Sale Price</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(product)}
                    className={styles.row}
                  >
                    <td>{product.product_name}</td>
                    <td>{product.hindi_name}</td>
                    <td>{product.local_name}</td>
                    <td>{product.product_quantity}</td>
                    <td>{product.buy_price}</td>
                    <td>{product.sale_price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      )}

    </div>
  );
};

export default SearchInventory;
